import React from 'react';
import styled, {keyframes} from 'styled-components';
import PrizeCards from "./prizeDetails";

const fadeInUp = keyframes`
    0% {
        opacity: 0;
        transform: translateY(0px) scale(0);
    }
    100% {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
`;

const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
`;
const ModalContent = styled.div`
    position: relative;
    background: linear-gradient(135deg, #118AB2, #0b6b8a);
    border: 8px solid #DCA831;
    border-radius: 20px;
    width: 90%;
    max-width: 400px;
    color: white;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: column;
`;

const ScrollableContent = styled.div`
    overflow-y: auto;
    padding: 25px;
    padding-top: 50px; // space for the button
    scrollbar-width: none;
    overscroll-behavior: contain;

    @media (max-width: 500px) {
        padding: 20px;
        padding-top: 50px;
    }

    h2 {
        margin-bottom: 15px;
        font-size: 26px;
    }

    p {
        text-align: left;
        font-size: 16px;
    }

    img {
        width: 100%;
        height: auto;
        border-radius: 10px;
        margin-bottom: 10px;
    }
`;


const CloseButton = styled.button`
    background: #DCA831;
    border: none;
    color: black;
    padding: 8px 16px;
    border-radius: 10px;
    cursor: pointer;
    font-weight: bold;
    font-size: 16px;
    transition: background 0.3s;
    text-align: center;

    &:hover {
        background: #f0c350;
    }
`;

const StepItem = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: start;
    gap: 10px;
    margin-bottom: 12px;
    font-size: 16px;
    line-height: 1.4;
`;
const StepIcon = styled.img`
    max-height: 20px;
    max-width: 20px;
    margin-top: 2px;
`;

interface ModalProps {
    onClose: () => void;
    windowHeight: number;
}

const CloseIcon = styled.img`
    position: absolute;
    top: 0px;
    right: 0px;
    width: 35px;
    height: 35px;
    max-width: 35px;
    max-height: 35px;
    object-fit: contain;
    cursor: pointer;
    z-index: 10;
    transform: translate(50%, -50%);
`;


export const HowToPlayModal: React.FC<ModalProps> = ({onClose, windowHeight}) => {
    return (
        <Overlay>
            <ModalContent style={{
                height: windowHeight * .8
            }}>
                <CloseIcon src="./crossx.png" alt="Close" draggable={false} onClick={onClose}/>
                <ScrollableContent>
                    <h2 style={{
                        fontWeight: 'bold',
                        textAlign: "center"
                    }}>How to Play Tambola</h2>
                    <StepItem>
                        <StepIcon src="./number-1.svg" alt="Step 1"/>
                        <p>Numbers will be called one by one.</p>
                    </StepItem>
                    <StepItem>
                        <StepIcon src="./number-2.svg" alt="Step 2"/>
                        <p>Tap the numbers on your ticket if they match.</p>
                    </StepItem>
                    <img draggable={false}
                         src="https://cdn.timepass.games/images/b8421aa5-324d-4fc9-b21a-f8ee9d2ed643.png"
                         alt="How to Play"/>
                    <StepItem>
                        <StepIcon src="./number-3.svg" alt="Step 3"/>
                        <p>Mark all the numbers to claim a Full House and win the game.</p>
                    </StepItem>
                    <StepItem>
                        <StepIcon src="./number-4.svg" alt="Step 4"/>
                        <p>Be quick to mark the number before it vanishes, others are racing too!</p>
                    </StepItem>
                    <PrizeCards/>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}>
                        <CloseButton onClick={onClose}>Got It!</CloseButton>
                    </div>
                </ScrollableContent>
            </ModalContent>
        </Overlay>
    );
};
